import { useCallback, useContext, useEffect, useState } from "react";
import invoicePattern from "../pages/Invoice/InvoicePattern";
import invoicePatternGST from "../pages/Invoice/InvoicePatternGST";
import db from "../resources/db";
import { ConfigContext } from "./ConfigContext";

export function useCreateInvoice() {

    const { Config, setConfig, getCompany, getCustomerList } = useContext(ConfigContext);

    const [Products, setProducts] = useState([]);
    const [CustomerName, setCustomerName] = useState('Cash')
    const [CustomerContact, setCustomerContact] = useState('')
    const [CustomerDetails, setCustomerDetails] = useState('')
    const [CustomerGST, setCustomerGST] = useState('')
    const [AmtPaid, setAmtPaid] = useState(0);
    const [date, setDate] = useState(Date());
    const [saletype, setSaletype] = useState(
        Config.gst.enabled ? 'intrastate' : 'nonGst'
    )
    const [invoiceManual, setInvoiceManual] = useState(Config.invoiceManual || false);
    const [CustomerList, setCustomerList] = useState([]);
    let [Company, setCompany] = useState({});

    /** Clears the form inputs */
    const clearAll = useCallback(() => {
        setCustomerDetails('');
        setCustomerContact('');
        setCustomerName('');
        setCustomerGST('')
        setProducts([]);
        setAmtPaid(0);
        setDate(Date());
        setSaletype(Config.gst.enabled ? 'intrastate' : 'nonGst')
        setCustomerList([]);
        setCompany({});
    }, [Config.gst.enabled]);

    useEffect(() => {
        getCustomerList().then((res) => {
            setCustomerList(res);
        })

        getCompany().then((res) => {
            setCompany(res);
        })
        return () => {
            clearAll();
        }
    }, [clearAll, getCompany, getCustomerList]);

    useEffect(() => {
        const posCode = CustomerGST?.substring(0, 2);
        const myposCode = Company.gst?.substring(0, 2);
        if (Config.gst.enabled) {
            if (posCode === myposCode) {
                setSaletype('intrastate');
            } else {
                setSaletype('interstate');
            }
        }
    }, [CustomerGST, Company, Config.gst.enabled]);

    function aggregateTotals() {
        // calucate subtotal & total
        let subTotal = 0;
        if (Products.length) {
            subTotal = Products.reduce((sum, product) => {
                let totalsum = sum + product.amount;
                return totalsum
            }, 0)
        }

        let gstTotal = 0;
        if (Products.length) {
            gstTotal = Products.reduce((sum, product) => {
                let totalsum = sum + product.gstAmt;

                return totalsum
            }, 0)
        }

        let total = subTotal;
        if (Config.gst.enabled) {
            total = subTotal + gstTotal;
        }

        return {
            subTotal, gstTotal, total
        }
    }

    /** Add Product to table */
    const addProduct = (item) => {
        setProducts([...Products, item])

        if (CustomerName === 'Cash') {
            if (Config.gst.enabled) {
                setAmtPaid(AmtPaid + (parseFloat(item.total)));
            } else {
                setAmtPaid(AmtPaid + parseFloat(item.amount));
            }
        }
    }

    /** Remove product item by id
    * @param id
    * @param pname Product Name
    * @param quan - Quantity
    */
    const removeProduct = (id, pname, quan) => {
        let pLeft = Products.filter(product => (product.id !== id))
        setProducts(pLeft)
        // console.log(quan);

        db.stocks.where("productName").equals(pname).modify((value, ref) => {
            // console.log(value , ref)
            let q = value.quantity
            ref.value.quantity = q + parseInt(quan)
            console.log("Stock removeProduct updated");
        })

        if (CustomerName === 'Cash') {
            if (Config.gst.enabled) {
                setAmtPaid(AmtPaid - (parseFloat(Products[id - 1].total)));
            } else {
                setAmtPaid(AmtPaid - parseFloat(Products[id - 1].amount ? Products[id - 1].amount : 0));
            }
        }
    }


    /** Print Bill from PDF
     * @param invoice
     */
    const printBill = (invoice) => {
        let print = document.getElementById('print').contentWindow;
        invoice.gstEnabled ?
            print.document.write(invoicePatternGST(invoice))
            : print.document.write(invoicePattern(invoice))
        print.document.close();
        print.focus();
        print.print();
        // console.log(print);

    }

    return {
        aggregateTotals, addProduct,
        Config, setConfig, Company,
        invoiceManual, setInvoiceManual,
        CustomerList, setCustomerList,
        CustomerName, setCustomerName,
        CustomerContact, setCustomerContact,
        CustomerDetails, setCustomerDetails,
        CustomerGST, setCustomerGST,
        saletype, setSaletype,
        AmtPaid, setAmtPaid,
        date, setDate,
        removeProduct,
        printBill,
        clearAll,
        Products
    }
}



